<script>
import baseList from "@/views/components/base/baseList.vue";

import { Button } from "view-design";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "reverb",
        key: "reverb_id",
        url: {},
        output: false,
      },
      data: {},
      menus: [
        {
          label: "回声树列表",
          name: "reverb_list",
          auth: "/admin/reverb/lists",
          // badge: { mname: "statisticsstats", scene: "recycle_notverify" },
        },
        {
          label: "助力列表",
          name: "reverb_info",
          auth: "/admin/reverbHelp/lists",
        },
        {
          label: "成员列表",
          name: "reverbBound_list",
          auth: "/admin/reverbBound/lists",
        },
      ],
      actions: [
        // {
        //   label: "创建回声树",
        //   icon: "md-add",
        //   onClick: this.toAdd,
        //   auth: "/admin/reverb/add",
        // },
      ],
      tactions: [
        // { label: '导出数据', type: 'success', onClick: this.exportData.bind(this, '商家数据', 0), auth: '/admin/spot/lists' },
        // { label: '导出全部数据', type: 'error', onClick: this.exportData.bind(this, '商家数据', 1), auth: '/admin/spot/lists' },
      ],
      query: {},
      currentRow: null,
      filters: [
        { label: "回声树名称", name: "title", value: "", type: "input" },
      ],
      tableCols: [
        {
          title: "ID",
          width: 100,
          key: "reverb_id",
        },
        {
          title: "回声树名",
          minWidth: 120,
          key: "title",
        },
        {
          title: "创建人",
          minWidth: 120,
          key: "publish_name",
        },
        {
          title: "成员人数",
          minWidth: 100,
          key: "bound_num",
        },
        {
          title: "创建时间",
          minWidth: 120,
          key: "create_time",
        },
        {
          title: "二维码",
          minWidth: 100,
          key: "code",
          viewimage: true,
        },
        {
          title: "状态",
          align: "center",
          key: "status",
          minWidth: 100,
          switch: true,
          disabled: false,
        },
        {
          title: "操作",
          align: "center",
          minWidth: 300,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              const row = param.row;
              let directives = [
                { name: "auth", value: "/admin/reverbHelp/lists" },
              ];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="info"
                  style={{ margin: "4px 5px" }}
                >
                  助力
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              const row = param.row;
              let directives = [
                { name: "auth", value: "/admin/reverbBound/lists" },
              ];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toreverbBound(currentRow)}
                  type="success"
                  style={{ margin: "4px 5px" }}
                >
                  成员
                </Button>
              );
            },
            "edit",
            "delete",
            // (vm, h, currentRow, param) => {
            //   const row = param.row;
            //   let directives = [{ name: "auth1", value: "/admin/reverb/edit" }];
            //   return (
            //     <Button
            //       {...{ directives }}
            //       size="small"
            //       onClick={() => this.Detail(currentRow)}
            //       type="info"
            //       style={{ margin: "4px 5px" }}
            //     >
            //       详情
            //     </Button>
            //   );
            // },
          ],
          auth: {
            del: "/admin/reverb/del",
            edit: "/admin/reverb/edit",
          },
        },
      ],
    };
  },
  created() {},

  methods: {
    toHelpList() {
      $utils.url.push({
        name: "reverb_info",
        query: {
          action: "info",
        },
      });
    },
    toInfo(row) {
      $utils.url.push({
        name: "reverb_info",
        query: {
          action: "info",
          qv: row.reverb_id,
        },
      });
    },
    toreverbBound(row) {
      $utils.url.push({
        name: "reverbBound_list",
        query: {
          action: "reverbBound",
          qv: row.reverb_id,
        },
      });
    },
    Detail(row) {
      this.$Modal.info({
        title: row.title,
        width: 800,
        render: () => <div domPropsInnerHTML={row.detail}></div>,
      });
    },
  },
};
</script>
